export const ANALYTICS_EVENT_NAMES = {
  welcomePageViewed: "welcome_page_viewed",
  welcomeContinueClicked: "welcome_continue_clicked",
  welcomeLogoUploadClicked: "welcome_logo_upload_clicked",
  verifyEmailPageViewed: "verify_email_page_viewed",
  verificationConfirmClicked: "verification_confirm_clicked",
  verificationResendClicked: "verification_resend_clicked",
  verificationSuccess: "verification_success",
  upgradeModalViewed: "upgrade_modal_viewed",
  upgradeModalSubscribeClicked: "upgrade_modal_subscribe_clicked",
  checkoutPageViewed: "checkout_page_viewed",
  checkoutSuccess: "checkout_success",
  campaignNewPageViewed: "campaign_new_page_viewed",
  campaignDetailsStepViewed: "campaign_details_step_viewed",
  campaignDetailsContinueClicked: "campaign_details_continue_clicked",
  campaignLocationAddOnMap: "campaign_location_add_on_map",
  campaignStartDateSelected: "campaign_start_date_selected",
  campaignInfluencerCountChanged: "campaign_influencer_count_changed",
  campaignOfferStepViewed: "campaign_offer_step_viewed",
  campaignCompensationGiftedSelected: "campaign_compensation_gifted_selected",
  campaignCompensationPaidSelected: "campaign_compensation_paid_selected",
  campaignPlatformInstagramSelected: "campaign_platform_instagram_selected",
  campaignPlatformTiktokSelected: "campaign_platform_tiktok_selected",
  campaignOfferContinueClicked: "campaign_offer_continue_clicked",
  campaignCollaborationTypeStepViewed:
    "campaign_collaboration_type_step_viewed",
  campaignCreativeFreedomSelected: "campaign_creative_freedom_selected",
  campaignPromoOffersSelected: "campaign_promo_offers_selected",
  campaignCollaborationContinueClicked: "campaign_collaboration_continue_clicked",
  campaignDeliverablesStepViewed: "campaign_deliverables_step_viewed",
  campaignScheduleClicked: "campaign_schedule_clicked",
  homeInviteCreatorsClicked: "home_invite_creators_clicked",
  homeCreateCampaignClicked: "home_create_campaign_clicked",
  creatorInvitePageViewed: "creator_invite_page_viewed",
  creatorInviteSendInvitationClicked: "creator_invite_send_invitation_clicked",
  creatorInviteConfirmSendClicked: "creator_invite_confirm_send_clicked",
  bookingCancellationInitiated: "booking_cancellation_initiated",
  bookingCancellationReasonSelected: "booking_cancellation_reason_selected",
  bookingCancellationSubmitted: "booking_cancellation_submitted",
  bookingCancellationAbandoned: "booking_cancellation_abandoned",
} as const;

export type EventName =
  (typeof ANALYTICS_EVENT_NAMES)[keyof typeof ANALYTICS_EVENT_NAMES];

export const EVENT_NAME_SNAKE_CASE_REGEX = /^[a-z0-9]+(_[a-z0-9]+)*$/;

export const isSnakeCaseEventName = (eventName: string): boolean => {
  return EVENT_NAME_SNAKE_CASE_REGEX.test(eventName);
};
